import { p as promiseResolve, b as bootstrapLazy } from './index-bcd4d8bd.js';

/*
 Stencil Client Patch Esm v2.0.3 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["rms-button_8",[[0,"rmsx-demo",{"client":[32],"author":[32],"loginWithPopup":[32],"isOpen":[32]}],[1,"rms-feedback",{"displayName":[1,"display-name"],"serviceName":[1,"service-name"],"author":[1],"fetchToken":[16],"endpointEnv":[1,"endpoint-env"],"isOpen":[4,"is-open"],"isOpened":[32],"submitStatus":[32]}],[1,"rms-button"],[1,"rms-form",{"rating":[32],"isAnonymous":[32],"message":[32]}],[0,"rms-overlay-loader",{"status":[1]}],[1,"rms-modal"],[1,"rms-loader",{"status":[1]}],[1,"rms-rating",{"value":[2],"hover":[32],"selectedValue":[32]}]]]], options);
  });
};

export { defineCustomElements };
